var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 61,
    viewBox: "0 0 24 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6725 21.841L16.3633 23.9201V18.0986L19.6725 15.3923V21.841Z",
    fill: "#11706C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3624 18.0984L9.54297 14.013V9.15479L19.6751 15.3921L16.3624 18.0984Z",
    fill: "#65E2DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6725 21.8411L23.9485 24.5474L20.6393 26.6265L16.3633 23.9202L19.6725 21.8411Z",
    fill: "#25B5AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4082 37.4412V42.6459L4.67798 48.6753V0L0 2.91768V57.6224L19.0827 45.969V34.5374L14.4082 37.4412Z",
    fill: "#D6FFFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 57.411L4.8651 60.5366L23.9478 48.8832L19.0827 45.7715L0 57.411Z",
    fill: "#11706C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9476 48.8832V31.8311L9.54284 22.884V9.15499L19.675 15.3923V21.841L23.9995 24.6097L23.951 12.0727L4.67773 0V48.8832L9.54284 45.6606V28.4976L19.0859 34.5374V45.7715L23.9476 48.8832Z",
    fill: "#3CCCC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49a342981cdaddb149312c265e60b9ad.svg";
export { ForwardRef as ReactComponent };